module.exports = __webpack_public_path__ + "static/img/全链路品牌宣教@2x.091d2308.png";